const LOGIN = "api/common/admin/login/";
const ACCOUNTList = "api/common/account/";
const ACCOUNT_LIST_V2 = "api/common/v2/account/";
const USERList = "api/common/user/";
const USER_LIST_V2 = "api/common/v2/user/";
const ADMINUserCreate = "api/common/user-create/";
const AdminUserCount = "api/common/admin/count/";
const USER = "api/common/user/";

export const API = {
  LOGIN,
  ACCOUNTList,
  ACCOUNT_LIST_V2,
  USERList,
  USER_LIST_V2,
  ADMINUserCreate,
  AdminUserCount,
  USER,
};
